import { createContext, useContext } from "react";
import type { TFunction } from "i18next";
import type { IncorporationWizardInitialData } from "@/schemas/incorporation";

export type StepComponentType = React.FC & {
  title: string | ((t: TFunction) => string);
  description?: string | ((t: TFunction) => string);
  /** 
   * se puede usar zod schema para validar tanto el form como la data q entra para 
   * saber si el step es completo o no, todo cuando ya sabemos la estructura de datos
   * cambiar any por el tipo de data que entra usando zod schema tmbin
   */
  isComplete?: (data: IncorporationWizardInitialData) => boolean;
  /** 
   * this mostly use by one step the step-progress-panel (progress can be a separate view that build and show steps)
   * but since step-progress-panel need to know the currIndex of the wizard, 🐔 and 🐣 problem
   * that's why this prop exists only for one step to use 🫠
   * */
  hideFromProgressPanel?: boolean;
  // Optional: Add more metadata
  // icon?: string;
  // description?: string;
};

type IncorporationWizardFormContextType = {
  currIndex: number;
  setCurrIndex: (index: number) => void;
  steps: StepComponentType[];
  data?: IncorporationWizardInitialData;
  setData: React.Dispatch<React.SetStateAction<IncorporationWizardInitialData | undefined>>;
  canNext: boolean;
  canBack: boolean;
  next: () => void;
  back: () => void;
};

export const IncorporationWizardFormContext =
  createContext<IncorporationWizardFormContextType>({
    currIndex: 0,
    setCurrIndex: () => {},
    steps: [],
    data: undefined,
    setData: () => {},
    canNext: false,
    canBack: false,
    next: () => {},
    back: () => {},
  });

export function useIncorporationWizardFormCtx() {
  const ctx = useContext(IncorporationWizardFormContext);
  if (!ctx) {
    throw new Error(
      "useIncorporationWizardFormCtx hook should be use inside a Incorporation wizard form provider"
    );
  }
  return ctx;
}

